import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, Eye } from "lucide-react";
import { errMsg, fmtPts } from "../../lib/api";
import { adminApi } from "../../lib/adminApi";
import { RoundSelect } from "../RoundSelect";
import { Submissions } from "../Submissions";
import { StatusBadge } from "./AdminPrivateList";

const ReadOnlyBoard = ({ rows }) => (
  <div className="card-surface overflow-x-auto" data-testid="admin-private-leaderboard">
    <table className="w-full text-sm">
      <thead><tr className="text-left font-mono text-[10px] uppercase tracking-widest text-slate-400 border-b border-[#26334D]">
        <th className="px-3 py-2">#</th><th className="px-3 py-2">Giocatore</th><th className="px-3 py-2 text-right">Punti</th><th className="px-3 py-2 text-right">Esatti</th><th className="px-3 py-2 text-right">Giocate</th>
      </tr></thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={5} className="px-3 py-4 text-slate-500">Nessun iscritto.</td></tr>}
        {rows.map((r) => (
          <tr key={r.user_id} className="border-b border-[#26334D]/60" data-testid={`admin-private-row-${r.user_id}`}>
            <td className="px-3 py-2 font-display font-black">{r.rank}</td>
            <td className="px-3 py-2 font-semibold">{r.name}</td>
            <td className="px-3 py-2 text-right font-display font-black text-emerald-400">{fmtPts(r.points)}</td>
            <td className="px-3 py-2 text-right text-slate-300">{r.exact}</td>
            <td className="px-3 py-2 text-right text-slate-400">{r.played}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const AdminPrivateDetail = ({ tid, onBack }) => {
  const [t, setT] = useState(null);
  const [round, setRound] = useState(null);
  useEffect(() => {
    adminApi.get(`/private-tournaments/${tid}`).then((r) => { setT(r.data); setRound(r.data.current_round); }).catch((e) => toast.error(errMsg(e)));
  }, [tid]);

  if (!t) return <div className="card-surface h-40 animate-pulse" />;
  const sc = t.scoring || {};
  return (
    <div className="space-y-6" data-testid="admin-private-detail">
      <div className="flex items-center justify-between gap-3">
        <button onClick={onBack} className="flex items-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="admin-private-back"><ArrowLeft size={16} /> Tornei privati</button>
        <span className="flex items-center gap-1.5 text-xs text-amber-400 font-mono uppercase" data-testid="admin-readonly-badge"><Eye size={14} /> Sola visualizzazione</span>
      </div>
      <div>
        <h2 className="font-display text-3xl font-black uppercase flex flex-wrap items-center gap-3">{t.name} <StatusBadge status={t.status} /></h2>
        <p className="text-sm text-slate-400 mt-1" data-testid="admin-private-info">
          {t.competition_name} · creato da <span className="text-white">{t.creator_name}</span> · {t.members_count} giocatori · giornata attuale: {t.current_round_label || "—"}
        </p>
        <p className="text-xs text-slate-500 mt-1 font-mono">Punti: fissa {sc.fisse} · doppia {sc.doppie} · esatto {sc.esatto} · bonus {sc.bonus}</p>
      </div>
      <ReadOnlyBoard rows={t.leaderboard} />
      {t.rounds.length > 0 && (
        <div className="space-y-4">
          <RoundSelect rounds={t.rounds} value={round} onChange={setRound} />
          {round && <Submissions tid={tid} round={round} client={adminApi} base="/private-tournaments" />}
        </div>
      )}
    </div>
  );
};
